import styled from "styled-components";

export const KpiColumn = styled.div`
    display: flex;
    justify-content: flex-end;
    font-size: 11px;
    font-weight: normal;
`;

export const KpiCellWrapper = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
`;

export const KpiCell = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    font-size: 11px;
`;

export const KpiBasisColumn = styled.div`
    display: flex;
    justify-content: flex-start;
    min-width: 50px;
`;


export const KpiBasisCell = styled(KpiBasisColumn)`
    flex-direction: column;
    align-items: flex-start;
    font-size: 11px;
    padding-left: 8px;
`;

export const KpiName = styled.div`
`;

export const Benchmark = styled.div`
    font-size: 10px;
`;